import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import './styles/app.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faDiamondExclamation } from '@fortawesome/pro-regular-svg-icons/faDiamondExclamation'
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle'
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck'
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear'
import { faRabbitRunning } from '@fortawesome/pro-solid-svg-icons/faRabbitRunning'
import { faArrowDownToLine } from '@fortawesome/pro-regular-svg-icons/faArrowDownToLine'
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation'
import { faFileArrowUp } from '@fortawesome/pro-solid-svg-icons/faFileArrowUp'
import { faFolderOpen } from '@fortawesome/pro-solid-svg-icons/faFolderOpen'
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen'
import { faTrashCan } from '@fortawesome/pro-solid-svg-icons/faTrashCan'

/* add icons to the library */
library.add(faDiamondExclamation);
library.add(faGoogle);
library.add(faCircleCheck);
library.add(faGear);
library.add(faRabbitRunning);
library.add(faArrowDownToLine);
library.add(faCircleExclamation);
library.add(faFileArrowUp);
library.add(faFolderOpen);
library.add(faPen);
library.add(faTrashCan);

createApp(App)
.component("font-awesome-icon", FontAwesomeIcon)
.use(store)
.use(router)
.use(VueAxios, axios)
.use(Vuex)
.mount('#app');